module.exports = __webpack_public_path__ + "img/ECC.adafbe85.webp";